/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PersonAppointment } from './PersonAppointment';
import {
    PersonAppointmentFromJSON,
    PersonAppointmentFromJSONTyped,
    PersonAppointmentToJSON,
    PersonAppointmentToJSONTyped,
} from './PersonAppointment';
import type { AppointmentStatusEnum } from './AppointmentStatusEnum';
import {
    AppointmentStatusEnumFromJSON,
    AppointmentStatusEnumFromJSONTyped,
    AppointmentStatusEnumToJSON,
    AppointmentStatusEnumToJSONTyped,
} from './AppointmentStatusEnum';

/**
 * a light version of appointment for display
 * @export
 * @interface LightAppointment
 */
export interface LightAppointment {
    /**
     * the unique identifier of the appointment
     * @type {string}
     * @memberof LightAppointment
     */
    uuid?: string;
    /**
     * the unique identifier of the appointment
     * @type {string}
     * @memberof LightAppointment
     */
    doctorUuid?: string;
    /**
     * the unique identifier of the patient
     * @type {string}
     * @memberof LightAppointment
     */
    patientUuid?: string;
    /**
     * the complete name of the doctor for the appointment
     * @type {string}
     * @memberof LightAppointment
     */
    doctorName?: string;
    /**
     * 
     * @type {AppointmentStatusEnum}
     * @memberof LightAppointment
     */
    status?: AppointmentStatusEnum;
    /**
     * The appointment date time
     * @type {string}
     * @memberof LightAppointment
     */
    appointmentDateTime?: string;
    /**
     * The appointment duration
     * @type {number}
     * @memberof LightAppointment
     */
    appointmentDuration?: number;
    /**
     * The name of the appointment type
     * @type {string}
     * @memberof LightAppointment
     */
    appointmentTypeName?: string;
    /**
     * the comment from the patient to the doctor
     * @type {string}
     * @memberof LightAppointment
     */
    comment?: string;
    /**
     * The location of the institute
     * @type {string}
     * @memberof LightAppointment
     */
    instituteLocation?: string;
    /**
     * The name of the institute
     * @type {string}
     * @memberof LightAppointment
     */
    instituteName?: string;
    /**
     * The time when patient arrive in waiting room
     * @type {string}
     * @memberof LightAppointment
     */
    arrivalTime?: string;
    /**
     * 
     * @type {PersonAppointment}
     * @memberof LightAppointment
     */
    personAppointment?: PersonAppointment;
    /**
     * The street of the institute's address
     * @type {string}
     * @memberof LightAppointment
     */
    instituteStreet?: string;
    /**
     * The postal code and locality of the institute's address
     * @type {string}
     * @memberof LightAppointment
     */
    instituteFullLocality?: string;
    /**
     * The country of the institute's address
     * @type {string}
     * @memberof LightAppointment
     */
    instituteCountry?: string;
    /**
     * true if the cancellation is available
     * @type {boolean}
     * @memberof LightAppointment
     */
    cancelAvailable?: boolean;
    /**
     * true if the update is available
     * @type {boolean}
     * @memberof LightAppointment
     */
    updateAvailable?: boolean;
}



/**
 * Check if a given object implements the LightAppointment interface.
 */
export function instanceOfLightAppointment(value: object): value is LightAppointment {
    return true;
}

export function LightAppointmentFromJSON(json: any): LightAppointment {
    return LightAppointmentFromJSONTyped(json, false);
}

export function LightAppointmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): LightAppointment {
    if (json == null) {
        return json;
    }
    return {
        
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'doctorUuid': json['doctorUuid'] == null ? undefined : json['doctorUuid'],
        'patientUuid': json['patientUuid'] == null ? undefined : json['patientUuid'],
        'doctorName': json['doctorName'] == null ? undefined : json['doctorName'],
        'status': json['status'] == null ? undefined : AppointmentStatusEnumFromJSON(json['status']),
        'appointmentDateTime': json['appointmentDateTime'] == null ? undefined : json['appointmentDateTime'],
        'appointmentDuration': json['appointmentDuration'] == null ? undefined : json['appointmentDuration'],
        'appointmentTypeName': json['appointmentTypeName'] == null ? undefined : json['appointmentTypeName'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'instituteLocation': json['instituteLocation'] == null ? undefined : json['instituteLocation'],
        'instituteName': json['instituteName'] == null ? undefined : json['instituteName'],
        'arrivalTime': json['arrivalTime'] == null ? undefined : json['arrivalTime'],
        'personAppointment': json['personAppointment'] == null ? undefined : PersonAppointmentFromJSON(json['personAppointment']),
        'instituteStreet': json['instituteStreet'] == null ? undefined : json['instituteStreet'],
        'instituteFullLocality': json['instituteFullLocality'] == null ? undefined : json['instituteFullLocality'],
        'instituteCountry': json['instituteCountry'] == null ? undefined : json['instituteCountry'],
        'cancelAvailable': json['cancelAvailable'] == null ? undefined : json['cancelAvailable'],
        'updateAvailable': json['updateAvailable'] == null ? undefined : json['updateAvailable'],
    };
}

export function LightAppointmentToJSON(json: any): LightAppointment {
    return LightAppointmentToJSONTyped(json, false);
}

export function LightAppointmentToJSONTyped(value?: LightAppointment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uuid': value['uuid'],
        'doctorUuid': value['doctorUuid'],
        'patientUuid': value['patientUuid'],
        'doctorName': value['doctorName'],
        'status': AppointmentStatusEnumToJSON(value['status']),
        'appointmentDateTime': value['appointmentDateTime'],
        'appointmentDuration': value['appointmentDuration'],
        'appointmentTypeName': value['appointmentTypeName'],
        'comment': value['comment'],
        'instituteLocation': value['instituteLocation'],
        'instituteName': value['instituteName'],
        'arrivalTime': value['arrivalTime'],
        'personAppointment': PersonAppointmentToJSON(value['personAppointment']),
        'instituteStreet': value['instituteStreet'],
        'instituteFullLocality': value['instituteFullLocality'],
        'instituteCountry': value['instituteCountry'],
        'cancelAvailable': value['cancelAvailable'],
        'updateAvailable': value['updateAvailable'],
    };
}

